const features = [
  {
    icon: 'ri-time-line',
    title: 'After-Hours Service',
    description: "We clean while you're closed. Zero disruption to your team, zero interference with your workday. Walk into spotless every morning."
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Trusted & Insured',
    description: 'Fully licensed and insured with background-checked cleaners. Your office, equipment, and confidential documents are in safe hands.'
  },
  {
    icon: 'ri-star-smile-line',
    title: '5-Star Results',
    description: 'Consistently high-quality cleaning that impresses clients, boosts team morale, and keeps your workspace looking professional every day.'
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Reliable Scheduling',
    description: 'Flexible scheduling that adapts to your business calendar. Weekly, bi-weekly, or custom plans — we show up when we say we will.'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Professional Service',
    description: 'Trained cleaning professionals who understand commercial spaces. From conference rooms to break areas, every detail matters.'
  },
  {
    icon: 'ri-checkbox-circle-line',
    title: 'Satisfaction Guaranteed',
    description: "We stand behind our work. If you're not happy, we'll make it right — no questions asked."
  }
];

export default function WhyChooseUs() {
  return (
    <section id="why-choose-us" className="py-28 px-6 bg-gradient-to-b from-white to-[#f7f8fa]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-[720px] mx-auto mb-[72px]">
          <p className="text-[13px] font-bold tracking-[0.09em] uppercase text-[#0b5b96] mb-[14px]">Why Choose Us</p>
          <h2 className="font-extrabold text-[#161a20] leading-[1.15] tracking-tight mb-5" style={{ fontSize: 'clamp(2.25rem,4vw,3rem)' }}>
            Built for Busy Offices &amp; Demanding Professionals
          </h2>
          <p className="text-lg leading-relaxed text-[#5b6472]">
            We understand what commercial spaces need. Punctual, thorough, and consistently excellent — so your workspace always makes the right impression.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid gap-6" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-[20px] p-[34px_30px] border border-[#edeef0] shadow-[0_1px_2px_rgba(16,24,40,0.03)] transition-all duration-250 hover:shadow-[0_20px_40px_-18px_rgba(16,24,40,0.18)] hover:-translate-y-1 hover:border-[#e2e6ec]"
            >
              <div className="w-14 h-14 rounded-2xl bg-[#0b5b96]/[.09] flex items-center justify-center mb-[22px]">
                <i className={`${feature.icon} text-[26px] text-[#0b5b96]`}></i>
              </div>
              <h3 className="text-[19px] font-bold text-[#161a20] mb-[10px]">{feature.title}</h3>
              <p className="text-[15.5px] leading-relaxed text-[#5b6472]">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
